import { FC } from 'react'
import { ExternalLinkIcon, HelpCircleIcon, LogOutIcon, UserRoundCogIcon } from 'lucide-react'
import { setShowUserMenu, useAppDispatch, useAppSelector } from '../../redux'
import { ROUTES, useIntercom, useUser } from '../../utils'
import { Avatar } from '..'
import { StyledUserMenu } from '.'

const UserMenu: FC = () => {
  const dispatch = useAppDispatch()
  const { user } = useAppSelector((state) => state.user)
  const { logout } = useUser()
  const { showIntercomMessenger } = useIntercom()

  const openIntercom = () => {
    dispatch(setShowUserMenu(false))
    showIntercomMessenger()
  }

  return (
    <StyledUserMenu>
      <div className="backdrop" onClick={() => dispatch(setShowUserMenu(false))} />
      <div className="menu">
        <div className="user-details-container">
          <Avatar />
          <div className="user-details">
            <span className="user-name">{user?.displayName}</span>
            <span className="user-email">{user?.email}</span>
          </div>
        </div>
        <div className="button-list">
          {window.self === window.top && (
            <a href={ROUTES.external.account} target="_blank">
              <UserRoundCogIcon />
              Account
            </a>
          )}
          <button onClick={() => openIntercom()}>
            <HelpCircleIcon />
            Support
          </button>
          {window.self === window.top && (
            <>
              <hr />
              <a href={ROUTES.external.app} target="_blank">
                <ExternalLinkIcon />
                Open Social Curator
              </a>
            </>
          )}
          <hr />
          <button onClick={() => logout()}>
            <LogOutIcon />
            Log Out
          </button>
        </div>
      </div>
    </StyledUserMenu>
  )
}

export default UserMenu
